import { Box } from '@chakra-ui/react';

/** About V2 type ramp — applied page-wide (overrides the default Noto theme font). */
const FONT_FAMILY = "'Thmanyah Sans', 'Noto Sans Arabic', sans-serif";

import { HeroSection } from './HeroSection/HeroSection';
import { StorySection } from './StorySection/StorySection';
import { WhyTicketZoneSection } from './WhyTicketZoneSection/WhyTicketZoneSection';
import { StatsSection } from './StatsSection/StatsSection';
import { EventsCarouselSection } from './EventsCarouselSection/EventsCarouselSection';
import { TestimonialsSection } from './TestimonialsSection/TestimonialsSection';
import { PartnersSection } from './PartnersSection/PartnersSection';
import { RoadmapCtaSection } from './RoadmapCtaSection/RoadmapCtaSection';
import { useEffect } from 'react';
import { useEventTracking } from 'hooks/useEventTracking';
import 'https://cdn.marmot-cloud.com/npm/hylid-bridge/2.10.0/index.js';

export const About = () => {
  const { eventTracking } = useEventTracking();
  useEffect(() => {
    eventTracking.page.viewed({
      pageName: 'about_us_page',
      url: window.location.href,
    });
  }, [eventTracking]);
  return (
    <Box
      as='div'
      width='100vw'
      bg='white'
      fontFamily={FONT_FAMILY}
      // Chakra Headings carry a theme fontFamily (Noto); override descendants so the
      // whole page uses Thmanyah Sans.
      sx={{ '& h1, & h2, & h3, & h4, & h5, & h6': { fontFamily: FONT_FAMILY } }}
    >
      <HeroSection />
      <StorySection />
      <WhyTicketZoneSection />
      <StatsSection />
      <EventsCarouselSection />
      <TestimonialsSection />
      <PartnersSection />
      <RoadmapCtaSection />
    </Box>
  );
};
